/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Faq_7_AInputs */

const en_cp_faq_7_a = /** @type {(inputs: Cp_Faq_7_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A certificate with verified metrics, a public benchmark entry, a document pack (PRD, wiki, evidence log, proposal PDF) ready as P2MW/PKM/thesis attachments, and entry to the national Build Challenge.`)
};

const id_cp_faq_7_a = /** @type {(inputs: Cp_Faq_7_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sertifikat dengan metrik terverifikasi, entri benchmark publik, paket dokumen (PRD, wiki, log bukti, proposal PDF) yang siap jadi lampiran P2MW/PKM/skripsi, dan kesempatan ikut Build Challenge nasional.`)
};

/**
* | output |
* | --- |
* | "A certificate with verified metrics, a public benchmark entry, a document pack (PRD, wiki, evidence log, proposal PDF) ready as P2MW/PKM/thesis attachments, ..." |
*
* @param {Cp_Faq_7_AInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_faq_7_a = /** @type {((inputs?: Cp_Faq_7_AInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Faq_7_AInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_faq_7_a(inputs)
	return en_cp_faq_7_a(inputs)
});